import type {
  AuthenticationResponseJSON,
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
  RegistrationResponseJSON,
} from "@simplewebauthn/browser";
import { apiClient } from "./apiClient";

export type PasskeyCredential = {
  id: string;
  name: string | null;
  createdAt: string;
};

export const passkeysGateway = {
  async getRegistrationOptions(): Promise<{
    options: PublicKeyCredentialCreationOptionsJSON;
    challengeId: string;
  }> {
    return await apiClient.post("/auth/passkeys/register/options");
  },

  async verifyRegistration(data: {
    response: RegistrationResponseJSON;
    name?: string;
    challengeId: string;
  }): Promise<void> {
    return await apiClient.post("/auth/passkeys/register/verify", data);
  },

  async listPasskeys(): Promise<Array<PasskeyCredential>> {
    return await apiClient.get("/auth/passkeys");
  },

  async deletePasskey(id: string): Promise<void> {
    return await apiClient.delete(`/auth/passkeys/${id}`);
  },

  async getAuthenticationOptions(): Promise<{
    options: PublicKeyCredentialRequestOptionsJSON;
    challengeId: string;
  }> {
    return await apiClient.post("/auth/passkeys/authenticate/options");
  },

  async verifyAuthentication(data: {
    response: AuthenticationResponseJSON;
    challengeId: string;
  }): Promise<void> {
    return await apiClient.post("/auth/passkeys/authenticate/verify", data);
  },
};
